<template>
  <el-dialog
    class="modal-select-role"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="large"
    lock-scroll
    append-to-body
  >
    <div class="content" v-loading="isLoading">
      <div class="role-list">
        <!-- S 左侧 角色选择 -->
        <div class="role-list__left">
          <div class="container-header">
            <h3 class="container-label">当前用户可授权角色如下</h3>
            <label class="filter-rolename__label">
              <el-input
                v-model="roleName"
                @keyup.enter.native="$_search"
                placeholder="搜索角色"
                class="filter-rolename__input"
              ></el-input>
              <i @click.stop="$_search" class="icon-search__btn"></i>
            </label>
          </div>
          <div class="container-list roles-select__list">
            <!-- 预设角色 -->
            <div v-if="presets.length> 0" class="role-list__default">
              <h3>系统预设角色</h3>
              <ul class="roles-default">
                <li v-for="role in presets" :key="role.rid" class="role-item">
                  <el-radio
                    v-model="roleId"
                    :label="role.rid"
                    @change="$_changeRole(role)"
                  >{{role.roleName}}</el-radio>
                </li>
              </ul>
            </div>
            <!-- 自定义角色 -->
            <div v-if="customs.length> 0" class="role-list__custom">
              <h3>系统自定义角色</h3>
              <ul class="roles-custom">
                <li v-for="role in customs" :key="role.rid" class="role-item">
                  <el-radio
                    v-model="roleId"
                    :label="role.rid"
                    @change="$_changeRole(role)"
                  >{{role.roleName}}</el-radio>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- E 左侧 角色选择 -->
        <!-- S 右侧 功能权限预览 -->
        <div class="role-list__right">
          <div class="container-header">
            <h3 class="container-label">选中角色的功能权限预览</h3>
          </div>
          <div class="selected-box">
            <div class="title-box">
              <span class="menu-title">菜单名称</span>
              <span class="button-title">功能权限</span>
            </div>
            <el-scrollbar class="roles-tree-box" wrap-style="height: 564px;">
              <el-tree
                :data="showFunctionList"
                :props="defaultProps"
                :expand-on-click-node="false"
                default-expand-all
                empty-text="暂无权限"
                node-key="fid"
              >
                <div class="tree-node__custom" slot-scope="{node, data}">
                  <span class="tree-node__label" :title="node.label">{{node.label}}</span>
                  <div class="tree-node__buttons">
                    <span
                      v-for="item in data.buttonList"
                      :key="item.id"
                      class="button-item"
                    >{{item.name}}</span>
                  </div>
                </div>
              </el-tree>
            </el-scrollbar>
          </div>
        </div>
        <!-- E 右侧 功能权限预览 -->
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <div class="edit__btns">
        <el-button class="save__btn" @click="$_submit">保存</el-button>
        <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";

export default {
  name: "select-role",
  props: {
    title: { type: String, default: "" },
    bindRoleId: { type: Number, default: 0 },
    presetList: { type: Array, default: [] }, // 预设角色
    customList: { type: Array, default: [] } // 自定义角色
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      role: {},
      roleId: this.bindRoleId,
      roleName: "",
      functionList: [],
      presets: [], // 用于显示 的 预设角色 列表
      customs: [], // 用于显示 的 自定义角色 列表
      defaultProps: {
        children: "children",
        label: "name"
      }
    };
  },
  computed: {
    // 根据已选数据右侧进行预览
    showFunctionList() {
      return Utils.functionListToTree(this.functionList);
    }
  },
  methods: {
    $_search() {
      let roleName = this.roleName;
      let presets = this.presetList.filter(
        item => item.roleName.match(roleName) !== null
      );
      let customs = this.customList.filter(
        item => item.roleName.match(roleName) !== null
      );
      let presetIndex = presets.findIndex(item => item.rid === this.roleId);
      let customIndex = customs.findIndex(item => item.rid === this.roleId);
      if (presetIndex === -1 && customIndex === -1) {
        this.role = {};
        this.roleId = 0;
        this.functionList.splice(0);
      }
      this.presets = [...presets];
      this.customs = [...customs];
    },
    // 切换角色
    $_changeRole(role) {
      this.role = { ...role };
      this.functionList = role.functionList.concat([]);
    },
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
    $_submit() {
      if (this.roleId === 0) {
        $MessageBox.alert({ content: "请选择相应角色" });
        return false;
      }
      this.$emit("submit", this.role);
    }
  },
  created() {
    this.$_search();
    if (this.bindRoleId > 0) {
      let role = this.presets.find(item => item.rid === this.bindRoleId);
      if (typeof role === "undefined") {
        role = this.customs.find(item => item.rid === this.bindRoleId);
      }
      this.$_changeRole(role);
    }
  },
  mounted() {
    this.visible = true;
  }
};
</script>
<style lang="scss" scoped>
.content {
  height: 100%;
  padding: 20px 14px 16px;
}
.role-list {
  &__left,
  &__right {
    height: 641px;
    background: rgba(249, 249, 249, 1);
    border: 1px solid rgba(238, 238, 238, 1);
  }
  &__left {
    width: 429px;
    float: left;
  }
  &__right {
    float: right;
    width: 789px;
  }
  .container-header {
    position: relative;
    height: 40px;
    background-color: #f5f6f7;
    border-bottom: 1px solid #eee;
    h3 {
      padding-left: 15px;
      line-height: 40px;
      font-size: 12px;
      color: #535353;
    }
    .filter-rolename__label {
      position: absolute;
      top: 4px;
      right: 4px;
    }
    .filter-rolename__input {
      width: 240px;
      height: 32px;
      /deep/ .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
    .icon-search__btn {
      position: absolute;
      top: 7px;
      right: 10px;
      width: 16px;
      height: 16px;
      cursor: pointer;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url(~@/assets/images/icon-search__btn.png);
    }
  }
  .container-list {
    height: 507px;
    overflow-y: auto;
    background-color: #f9f9f9;
  }
  .roles-select__list {
    padding: 6px 15px;
    h3 {
      color: #3a3a3a;
      font-size: 14px;
      line-height: 30px;
    }
    .role-item {
      height: 30px;
      line-height: 30px;
      /deep/ .el-radio__label {
        color: #535353;
      }
    }
  }
}
.selected-box {
  display: flex;
  height: 600px;
  flex-direction: column;
  background-image: linear-gradient(90deg, #363c54 160px, #f9f9f9 161px);
  .title-box {
    height: 36px;
    font-size: 14px;
    display: flex;
    align-items: center;
    > span {
      padding-left: 16px;
    }
    .menu-title {
      width: 160px;
      color: #fff;
    }
    .button-title {
      color: #3a3a3a;
    }
  }
}
.roles-tree-box {
  position: relative;
  font-size: 12px;
  height: 564px;
  width: 100%;
  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
    overflow-y: scroll;
  }
  /deep/ .el-tree__empty-block {
    color: #fff;
    height: 420px;
  }
  /deep/ .el-tree-node {
    &:focus {
      > .el-tree-node__content {
        color: #49b2ef;
        background-color: transparent;
      }
    }
    &__content {
      color: #fff;
      min-height: 30px;
      height: auto;
      padding-top: 2px;
      &:hover {
        color: #49b2ef;
        background-color: transparent;
      }
    }
    &__children {
      .el-tree-node__expand-icon.is-leaf {
        padding: 4px;
        font-size: 12px;
      }
    }
  }
}
.selected-buttons {
  flex: 1;
  color: #535353;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  h3 {
    color: #3a3a3a;
    line-height: 36px;
    padding-left: 12px;
  }
}
.tree-node {
  &__custom {
    display: flex;
    width: 100%;
    align-items: center;
    overflow: hidden;
  }
  &__label {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #e0e0e0;
  }
  &__buttons {
    width: 626px;
    padding: 2px 0;
    padding-left: 16px;
    display: flex;
    flex-wrap: wrap;
    .button-item {
      display: inline-block;
      padding: 0 10px;
      margin: {
        right: 6px;
        bottom: 2px;
      }
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      color: #fff;
      background-color: #49b2ef;
      border-radius: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
    /deep/ .el-scrollbar__wrap {
      overflow: scroll;
    }
  }
}
</style>
